import script from "./UserManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagement.vue?vue&type=script&setup=true&lang=js"

import "./UserManagement.vue?vue&type=style&index=0&id=003469fc&lang=scss&scoped=true"
import "./UserManagement.vue?vue&type=style&index=1&id=003469fc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003469fc"]])

export default __exports__